import {
    CREATE_SUBSCRIPTION_REQUEST,
    CREATE_SUBSCRIPTION_REQUEST_SUCCESS,
    CREATE_SUBSCRIPTION_REQUEST_FAILURE,
    DELETE_SUBSCRIPTION_REQUEST,
    DELETE_SUBSCRIPTION_REQUEST_SUCCESS,
    DELETE_SUBSCRIPTION_REQUEST_FAILURE,
    EDIT_SUBSCRIPTION_REQUEST,
    EDIT_SUBSCRIPTION_REQUEST_SUCCESS,
    EDIT_SUBSCRIPTION_REQUEST_FAILURE,
    GET_SUBSCRIPTIONS_REQUEST,
    GET_SUBSCRIPTIONS_REQUEST_SUCCESS,
    GET_SUBSCRIPTIONS_REQUEST_FAILURE,
    EXPORT_SUBSCRIPTIONS_EXCEL_REQUEST,
    EXPORT_SUBSCRIPTIONS_EXCEL_REQUEST_SUCCESS,
    EXPORT_SUBSCRIPTIONS_EXCEL_REQUEST_FAILURE,
    EXPORT_SUBSCRIPTIONS_PDF_REQUEST,
    EXPORT_SUBSCRIPTIONS_PDF_REQUEST_SUCCESS,
    EXPORT_SUBSCRIPTIONS_PDF_REQUEST_FAILURE,
} from './mutation-types'
import api from "@/application"
import {RESET} from "../../mutation-types"
import {
    isPeriodInMonthsValid,
    MAX_PDF_REPORT_PERIOD_MONTHS,
    MAX_PDF_REPORT_PERIOD_ERROR,
} from "@/utils/datetime"

const actions = {

    createSubscription: async ({commit}, subscriptionData) => {
        commit(CREATE_SUBSCRIPTION_REQUEST)

        try {
            await api.subscriptions.createSubscription(subscriptionData)
            commit(CREATE_SUBSCRIPTION_REQUEST_SUCCESS)
        } catch (e) {
            commit(CREATE_SUBSCRIPTION_REQUEST_FAILURE)
            throw new Error(e.response.data.errorMessage)
        }
    },

    editSubscription: async ({commit}, {subscriptionId, subscriptionData}) => {
        commit(EDIT_SUBSCRIPTION_REQUEST)

        try {
            await api.subscriptions.editSubscription(subscriptionId, subscriptionData)
            commit(EDIT_SUBSCRIPTION_REQUEST_SUCCESS)
        } catch (e) {
            commit(EDIT_SUBSCRIPTION_REQUEST_FAILURE)
            throw new Error(e.response.data.errorMessage)
        }
    },

    getSubscriptions: async ({commit}, profileId) => {
        commit(GET_SUBSCRIPTIONS_REQUEST)

        try {
            const {data} = await api.subscriptions.getProfileSubscriptions(profileId)
            commit(GET_SUBSCRIPTIONS_REQUEST_SUCCESS, data)
        } catch (e) {
            commit(GET_SUBSCRIPTIONS_REQUEST_FAILURE)
            throw new Error(e.response.data.errorMessage)
        }
    },

    deleteSubscription: async ({commit}, subscriptionId) => {
        commit(DELETE_SUBSCRIPTION_REQUEST)

        try {
            await api.subscriptions.deleteSubscription(subscriptionId)
            commit(DELETE_SUBSCRIPTION_REQUEST_SUCCESS)
        } catch (e) {
            commit(DELETE_SUBSCRIPTION_REQUEST_FAILURE)
            throw new Error(e.response.data.errorMessage)
        }
    },

    exportSubscriptionsToExcel: async ({commit}, params = {}) => {
        commit(EXPORT_SUBSCRIPTIONS_EXCEL_REQUEST)

        try {
            const response = await api.subscriptions.exportSubscriptionsToExcel(params)
            commit(EXPORT_SUBSCRIPTIONS_EXCEL_REQUEST_SUCCESS, response)
            return response
        } catch (e) {
            commit(EXPORT_SUBSCRIPTIONS_EXCEL_REQUEST_FAILURE)
            throw new Error(e.response?.data?.errorMessage || 'Ошибка при формировании отчёта')
        }
    },

    exportSubscriptionsToPdf: async ({commit}, params = {}) => {
        // период формирования pdf-отчётов ограничен 6 месяцами
        if (!isPeriodInMonthsValid(params.start, params.end, MAX_PDF_REPORT_PERIOD_MONTHS)) {
            throw new Error(MAX_PDF_REPORT_PERIOD_ERROR)
        }

        commit(EXPORT_SUBSCRIPTIONS_PDF_REQUEST)

        try {
            const response = await api.subscriptions.exportSubscriptionsToPdf(params)
            commit(EXPORT_SUBSCRIPTIONS_PDF_REQUEST_SUCCESS, response)
            return response
        } catch (e) {
            commit(EXPORT_SUBSCRIPTIONS_PDF_REQUEST_FAILURE)
            throw new Error(e.response?.data?.errorMessage || 'Ошибка при формировании отчёта')
        }
    },

    resetSubscriptions: ({commit}) => {

        commit(RESET)
    },
}

export default actions